module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has(_vm.validationKey)
    }
  }, [_c('label', {
    attrs: {
      "for": "email-header"
    }
  }, [(_vm.isRequired) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.label))]), _vm._v(" "), _c('textarea', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validators),
      expression: "validators"
    }],
    ref: "textarea",
    staticClass: "form-control",
    attrs: {
      "id": _vm.name,
      "placeholder": _vm.label,
      "name": _vm.name,
      "data-vv-as": _vm.label
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }, 'textarea', _vm.$attrs, false)), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.validationKey)),
      expression: "errors.has(validationKey)"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.validationKey)))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("*Available shortcodes (click to insert at cursor):\n    "), _vm._l((_vm.shortcodes), function(code, idx) {
    return _c('span', {
      on: {
        "click": function($event) {
          return _vm.insertShortcode(code)
        }
      }
    }, [_c('strong', {
      staticClass: "cursor-pointer"
    }, [_vm._v("%" + _vm._s(code) + "%")]), (idx !== _vm.shortcodes.length - 1) ? [_vm._v(", ")] : _vm._e()], 2)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c3a41e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/ShortcodesEditor.vue
// module id = 1654
// module chunks = 1